module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7121/images/default-avatar.png"